<template>
  <div class="container" v-if="loading && !loadError">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-8 col-sm-12 col-s-8">
        <div id="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container" v-if="!loading && loadError">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-8 col-sm-12 col-s-8">
        <h2>😥</h2>
        {{ loadError }}
      </div>
    </div>
  </div>

  <div class="container" id="main" v-show="!loading && !loadError">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-8 col-sm-12 col-s-8 col-xl-8 col-xxl-6">
    <img v-if="config?.logo_url" :src="isDarkTheme && config.logo_url_dark ? config.logo_url_dark : config.logo_url" class="img-fluid">
    <br v-if="config?.logo_url">
    <br v-if="config?.logo_url">
    <h2 v-if="config?.name && !config.hide_title">{{ config.name }}</h2>
    <br>
    <div class="top_html" v-html="config?.top_html"></div>
    </div>
    </div>
    <br>
    <router-view :config="config"></router-view>
    <div class="container" id="footer">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-8 col-sm-12 col-s-8 col-xl-8 col-xxl-6">
      <br>
      <div class="foot_html" v-html="config?.bottom_html"></div>
      <br>
      <p v-if="!config?.hide_footer" class="monospaced">created with <a class="link-muted" href="https://laniakea.dev">laniakea looking glass</a></p>
      <div class="btn-group" v-if="!config?.hide_theme_switch">
        <a href="#" class="btn btn-sm" :class="{ active: isDarkTheme }" @click.prevent="toggleTheme" aria-current="page">
          <i class="fa-solid fa-moon"></i>
        </a>
        <a href="#" class="btn btn-sm" :class="{ active: !isDarkTheme }" @click.prevent="toggleTheme">
          <i class="fa-solid fa-sun"></i>
        </a>
      </div>
      <!--<LoginPopup v-if="!isLoggedIn" @login-success="handleLoginSuccess" />-->
      </div>
      </div>
    </div>
  </div>
  <br>
</template>

<script>
//import LoginPopup from './components/LoginPopup.vue'

export default {
  name: 'App',
  components: {
    //LoginPopup
  },
  data() {
    return {
      config: null,
      loading: true,
      loadError: false,
      isDarkTheme: this.getInitialTheme(),
      isSystemTheme: true,
      isLoggedIn: false,
    }
  },
  mounted() {
    this.isLoggedIn = localStorage.getItem('isLoggedIn') ?? false;
    this.loadConfig()
    this.applyTheme()
    if (this.config?.theme === 'auto') {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.handleSystemThemeChange)
    }
  },
  beforeUnmount() {
    if (this.config?.theme === 'auto') {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.handleSystemThemeChange)
    }
  },
  methods: {
    getInitialTheme() {
      return true
    },
    getSystemTheme() {
      return window.matchMedia('(prefers-color-scheme: dark)').matches
    },
    handleSystemThemeChange(e) {
      if (this.config?.theme === 'auto' && this.isSystemTheme) {
        this.isDarkTheme = e.matches
        this.applyTheme()
      }
    },
    applyTheme() {
      document.documentElement.setAttribute('data-bs-theme', this.isDarkTheme ? 'dark' : 'light')
    },
    async loadConfig() {
      try {
        const response = await fetch('/laniakea?q=hello')
        const data = await response.json()
        if (data.status === "success") {
          this.loading = false
          this.config = data.data
          document.title = this.config.page_title || this.config.name

          // Set theme based on config
          if (this.config.theme) {
            if (this.config.theme === 'dark') {
              this.isDarkTheme = true
              this.isSystemTheme = false
            } else if (this.config.theme === 'light') {
              this.isDarkTheme = false
              this.isSystemTheme = false
            } else if (this.config.theme === 'auto') {
              this.isDarkTheme = this.getSystemTheme()
              this.isSystemTheme = true
            }
            this.applyTheme()
          }

          // Set favicon
          let link = document.querySelector("link[rel~='icon']")
          if (!link) {
            link = document.createElement('link')
            link.rel = 'icon'
            document.head.appendChild(link)
          }
          if (this.config.favicon_url) {
            link.href = this.config.favicon_url
          }

          // Apply custom CSS
          if (this.config.css) {
            const style = document.createElement('style')
            style.innerHTML = this.config.css
            document.head.appendChild(style)
          }
        } else {
          this.loadError = data.data
        }
      } catch (e) {
        this.loadError = "Can't connect to server"
      }
    },
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme
      this.isSystemTheme = false
      this.applyTheme()
    },
    handleLoginSuccess() {
      // TODO: Handle successful login, e.g. refresh user data
      console.log('User logged in successfully')
      this.loadConfig()
      this.isLoggedIn = true
    }
  }
}
</script>

<style>
body,
html {
  transition: background-color 0.5s, color 0.5s;
}

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
}

.monospaced {
  font-family: "Ubuntu Mono", monospace;
}

.clickable {
  cursor: pointer;
}
.form-control{
  transition: background-color 0.5s, color 0.5s;
}
.btn{
  transition: background-color 0.5s, color 0.5s;
}
.dropdown-toggle{
  transition: background-color 0.5s, color 0.5s;
}
.link-muted{
  color: var(--bs-body-color);
}
.link-muted:hover{
  color: var(--bs-body-color);
}
</style>
